<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" filterable clearable="clearable">
                            <el-option v-for="item in insertDate.warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode + '-' + item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.status" clearable="clearable">
                            <el-option key="0" value="CREATE,PICK,PICKING,PICKCOMPLETE" label="默认(下发,提交拣配,拣货中,拣货完成)"></el-option>
                            <el-option key="6" value="PICKING" label="拣货中"></el-option>
                            <el-option key="3" value="PICKCOMPLETE" label="拣货完成"></el-option>
                            <el-option key="7" value="COMPLETE" label="完成"></el-option>
                            <el-option key="5" value="CLOSE" label="关闭"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.beginTime" value-format="yyyy-MM-dd HH:mm" type="date"  placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="配送详情">
                <el-button v-authority="'BACK_MENU1_M3_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">
                    导出EXCEL
                </el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" ref="table" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAllMain" @current-change="toggleRowExpansion">
                <el-table-column align="center" prop="children" type="expand">
                    <template slot-scope="scope">
                        <el-table v-if="!!scope.row.children" :data="scope.row.children" class="drop-down">
                            <el-table-column prop="matCode" label="物料编号">
                            </el-table-column>
                            <el-table-column prop="matName" label="物料描述">
                            </el-table-column>
                            <el-table-column prop="boxBarCode" label="箱号"></el-table-column>
                            <el-table-column prop="batchNo" label="批次"></el-table-column>
                            <el-table-column prop="matSpecs" label="规值" width="100px;"></el-table-column>
                            <el-table-column prop="matQuan" label="数量" width="80px;"></el-table-column>
                            <el-table-column prop="pickFlag" label="数量1" width="80px;"></el-table-column>
                            <el-table-column label="配送状态" align="center" prop="distrType">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.distrType == '' || scope.row.distrType == undefined">
                                        <span>{{!scope.row.pickFlag?"待检":"拣配中"}}</span>
                                    </span>
                                    <span v-if="scope.row.distrType == '10'">待配送</span>
                                    <span v-if="scope.row.distrType == '20'">配送中</span>
                                    <span v-if="scope.row.distrType == '30'">配送完成</span>
                                    <span v-if="scope.row.distrType == '40'">关闭</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="配送方式" align="center" prop="distrType">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.distrWay == '10'">AGV</span>
                                    <span v-if="scope.row.distrWay == '20'">人工</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="taskPathPoint" label="位置"></el-table-column>
                            <el-table-column prop="taskCode" label="任务号"></el-table-column>
                            <el-table-column prop="taskStatus" label="任务状态">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.taskStatus == 'START'">任务开始</span>
                                    <span v-if="scope.row.taskStatus == 'EXECUTE'">任务进行中</span>
                                    <span v-if="scope.row.taskStatus == 'CANCEL'">任务取消</span>
                                    <span v-if="scope.row.taskStatus == 'COMPLETE'">任务正常完成</span>
                                    <span v-if="scope.row.taskStatus == 'WARNCOMP'">任务异常</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laStartCode" label="是否发送AGV">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.agvFlag == false">否</span>
                                    <span v-if="scope.row.agvFlag == true">是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laStartCode" label="是否搬运中">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.distrType == '20' && scope.row.nowPointPlace == '0'">否</span>
                                    <span v-if="scope.row.distrType == '20' && scope.row.nowPointPlace == '1'">是</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="updateTime" label="时间"></el-table-column>
                        </el-table>
                        <div class="drop-down-else-div" v-else>暂无数据</div>
                    </template>
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="叫料单号" align="center" prop="pmCode">
                </el-table-column>
                <el-table-column label="需求时间" align="center" prop="requireTime">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs" v-if="false">
                </el-table-column>
                <el-table-column label="状态" align="center" prop="status">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'CREATE' || scope.row.status == '1'">下发</span>
                        <span v-if="scope.row.status == 'PICK' || scope.row.status == '2'">提交拣配</span>
                        <span v-if="scope.row.status == 'PICKING' || scope.row.status == '3'">拣货中</span>
                        <span v-if="scope.row.status == 'PICKCOMPLETE' || scope.row.status == '4'">拣货完成</span>
                        <span v-if="scope.row.status == 'CHECKOUT' || scope.row.status == '5'">配送出库</span>
                        <span v-if="scope.row.status == 'COMPLETE' || scope.row.status == '6'">完成</span>
                        <span v-if="scope.row.status == 'CLOSE' || scope.row.status == '7'">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column label="配送类型" align="center" prop="distrType" v-if="false">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distrType == '10'">待配送</span>
                        <span v-if="scope.row.distrType == '20'">配送中</span>
                        <span v-if="scope.row.distrType == '30'">配送完成</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="是否紧急" align="center" prop="topFlag">
                    <template slot-scope="scope">
                        <span>{{ scope.row.topFlag ? "是" : "否" }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="紧急原因" align="center" prop="topMessage">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "ProductionCall",
        data() {
            return {
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 要展开的行，数值的元素是row的key值
                expands: [],
                // 筛选条件
                mainSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "", //通道编号
                    pmCode: "", //	生产叫料编号
                    opCode: "", //	生产工单编号
                    prodCode: "", //	物料编号
                    matCode: "", //	物料编号
                    status: "CREATE,PICK,PICKING,PICKCOMPLETE", //	状态
                    beginTime: new Date(new Date().getTime() - 2*24*60*60*1000), // 开始时间
                    endTime: new Date(new Date().getTime() + 24*60*60*1000), // 结束时间
                },
                //多选
                checkListMain: [],

                insertDate: {
                    whCode: localStorage.getItem("whCode") || "",
                    requireTime: "", //需求时间
                    topFlag: false,
                    topMessage: "",
                    pmType: "ORDER", //工单/BOM
                    opCode: "",
                    prodCode: "",
                    matCode: "",
                    jihuaQuan: "",
                    quan: "",

                    orderList: [],
                    warehouseList: [],
                    materialList: [],
                    bomList: [],
                    matList: [],
                    resultList: [], //原因
                },
                factoryData: {},
                whCodeId: "",

                factoryList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                person: localStorage.getItem("user"),
                personNumber: localStorage.getItem("empNumber"),

                downloadLoading: false, //下载中
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
						this.mainData.nowPage=1;
                        this.getTableData(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },

        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.beginTime) {
                            return time.getTime() < new Date(_this.mainSearch.beginTime);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.endTime) {
                            return time.getTime() > new Date(_this.mainSearch.endTime);
                        }
                    }
                }
            },
        },
        methods: {
            toogleExpand(row) {
                let $table = this.$refs.table;
                $table.toggleRowExpansion(row);
            },
            toggleRowExpansion(row) {
                this.expands = [];
                this.expands.push(row.id);
            },
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.getTableData();
                }, 1000);
            },
            getTableData() {
                this.$http
                    .request({
                        url: "/api/stockProduceMat/getStockProductMatPage",
                        method: "GET",
                        params: {
                            // person: this.mainSearch.person || null,
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                            whCode: this.mainSearch.whCode || null,
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            status: this.mainSearch.status || null, //	状态
                            beginTime: this.mainSearch.beginTime || null, // 开始时间
                            endTime: this.mainSearch.endTime || null, // 结束时间
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 当前工厂的通道信息
             */
            getWarehouse(fcCode) {
                let fcCodeId;
                if (fcCode == undefined) {
                    fcCodeId = localStorage.getItem("fcCode") || "";
                } else {
                    fcCodeId = fcCode;
                }
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: fcCodeId || null,
                            // whCode: localStorage.getItem('whCode') || null
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.insertDate.warehouseList = resp.data.list || [];
                            if (localStorage.getItem("whCode") != "") {
                                this.mainSearch.whCode = localStorage.getItem("whCode") || "";
                            }
                        }
                    })
                    .catch((error) => {});
            },
            /**
             * 当前所有物料信息
             */
            getMaterial() {
                this.$http
                    .request({
                        url: "/api/material/getMaterialAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.insertDate.materialList = res.data.list;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            /**
             * 判断是否紧急
             */
            topFunction() {
                let dateBegin = new Date();
                let dateEnd = new Date(this.insertDate.requireTime);
                let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差
                let minutes = Math.floor(dateDiff / (60 * 1000)); //计算相差分钟数
                if (this.factoryData.urgentTime >= minutes) {
                    this.insertDate.topFlag = true;
                    this.getWarnType();
                } else {
                    this.insertDate.topFlag = false;
                    this.insertDate.topMessage = "";
                }
            },

            /**
             * 禁选
             */
            checkboxMain(row, rowIndex) {
                if (row.status == "CREATE") {
                    return true; // 不禁用
                } else {
                    return false; // 禁用
                }
            },
            /**
             * 全选
             */
            selectAllMain(val) {
                this.checkListMain = val;
            },

            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    whCode: localStorage.getItem("whCode") || "", //通道编号
                    pmCode: "", //	生产叫料编号
                    opCode: "", //	生产工单编号
                    prodCode: "", //	物料编号
                    matCode: "", //	物料编号
                    status: "CREATE,PICK,PICKING,PICKCOMPLETE", //	状态
                    beginTime: new Date(new Date().getTime() - 2*24*60*60*1000), // 开始时间
                    endTime: new Date(new Date().getTime() + 24*60*60*1000), // 结束时间
                };
            },
            //获取数据
            getFactoryAll() {
                this.$http
                    .request({
                        url: "/api/factory/getFactoryAll",
                        method: "GET",
                        params: {},
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.factoryList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    // person: this.mainSearch.person || null,
                    fcCode: this.mainSearch.fcCode || null, //	工厂编号
                    whCode: this.mainSearch.whCode || null,
                    matCode: this.mainSearch.matCode || null, //	物料编号
                    status: this.mainSearch.status || null, //	状态
                    beginTime: this.mainSearch.beginTime || null, // 开始时间
                    endTime: this.mainSearch.endTime || null, // 结束时间
                    pageNum: 1,
                    pageSize: 999999,
                };
                this.$http
                    .request({
                        url: "/api/stockProduceMat/getStockProductMatPage",
                        method: "GET",
                        params: paramsObj,
                    })
                    .then((resp) => {
                        resp.status == 100 ?
                            this.downLoad(resp.data.list || []) :
                            this.$notify.error({
                                message: "查询失败",
                            });
                    });
            },
            downLoad(list) {
                import("@/libs/Export2Excel").then((excel) => {
                    list.forEach(function(c) {
                        if (c.status == "CREATE" || c.status == "1") {
                            c["status"] = "下发";
                        } else if (c.status == "PICK" || c.status == "2") {
                            c["status"] = "提交拣配";
                        } else if (c.status == "PICKING" || c.status == "3") {
                            c["status"] = "拣货中";
                        } else if (c.status == "PICKCOMPLETE" || c.status == "4") {
                            c["status"] = "拣货完成";
                        } else if (c.status == "CHECKOUT" || c.status == "5") {
                            c["status"] = "配送出库";
                        } else if (c.status == "COMPLETE" || c.status == "6") {
                            c["status"] = "完成";
                        } else if (c.status == "CLOSE" || c.status == "7") {
                            c["status"] = "关闭";
                        }

                        if (c.topFlag == false) {
                            c["topFlag"] = "否";
                        } else if (c.topFlag == true) {
                            c["topFlag"] = "是";
                        }
                    });
                    const tHeader = [
                        "通道编号",
                        "生产叫料编号",
                        "需求时间",
                        "状态",
                        "操作人",
                        "是否紧急",
                        "紧急原因",
                        "创建时间",
                    ];
                    const filterVal = [
                        "whCode",
                        "pmCode",
                        "requireTime",
                        "status",
                        "person",
                        "topFlag",
                        "topMessage",
                        "createTime",
                    ];
                    const data = this.formatJson(filterVal, list);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "配送详情",
                    });
                    this.logContent = "导出";
                    this.logRemarks = "stock_product：导出配送详情记录";
                    this.systemLog();
                    this.downloadLoading = false;
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },
            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "配送详情",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            //添加默认时间
            // this.mainSearch.date = [];
            // this.mainSearch.date.push(moment().subtract('d', 1).format("YYYY-MM-DD HH:mm"));
            // this.mainSearch.date.push(moment().add('d', 1).format("YYYY-MM-DD HH:mm"));
            this.getWarehouse();
            this.getFactoryAll();
            /* 获取首页的数据 */
            this.getTableData();
        },
    };
</script>

<style scoped>
    .drop-down-else-div {
        width: 86%;
        margin-left: 3.5%;
        background-color: rgba(212, 209, 209, 0.3);
        padding: 2px 0;
    }
</style>